<template>
    <div class="container">
        <div class="timeline">
            <div class="row no-gutters justify-content-end justify-content-md-around align-items-start  timeline-nodes"
            v-for="(item,i) in eduTimeline" :key="i">
                <div class="col-10 col-md-5 order-3 order-md-1 timeline-content">
                    <img class="header-img img-fluid" :src='item.src' v-bind:alt="item.alt">
                    <div class="degree py-4">
                        <span>{{item.status}}</span>
                        {{item.degree}}
                        <div>{{item.spec}}</div>
                    </div>
                    <div class="institution py-3">{{item.uni}}<br><span>{{item.college}}</span></div>
                    <article class="description px-2 mt-4">
                        <strong class="title pl-3 ">{{item.title}}</strong>
                        <p class="subtitle">{{item.subtitle}}</p>
                    </article>
                </div>
                <div class="col-2 col-sm-1 px-md-3 order-2 timeline-image text-md-center"></div>
                <div class="col-10 col-md-5 order-1 order-md-3 py-3 timeline-date">
                    <span class="date">{{item.date}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EduTimeline",
        data() {
            return {
                eduTimeline: [
                    {
                        src: require('../../assets/ph_1.jpg'),
                        alt: "UB-Philosophy",
                        degree: "Ph.D :",
                        status: "dropped-out ",
                        spec: "International Relations",
                        uni: "University of Bucharest",
                        college: "Faculty of Philosophy",
                        title: "Legitimacy in International Relations:",
                        subtitle: "Human Rights and State Sovereignty in Humanitarian Crises",
                        date: "2015-2019"
                    },
                    {
                        src: require('../../assets/ph_2.jpg'),
                        alt: "UB-PhilosophyMaster",
                        degree: "Master's Degree :",
                        status: null,
                        spec: "International Development & Ethics of International Relations",
                        uni: "University of Bucharest",
                        college: "Faculty of Philosophy",
                        title: "Crisis in Eastern Ukraine:",
                        subtitle: "Analysing Russia's Intervention",
                        date: "2013-2015"
                    },
                    {
                        src: require('../../assets/ph_3.jpg'),
                        alt: "UB-PhilosophyBachelor",
                        degree: "Bachelor's Degree :",
                        status: null,
                        spec: "Philosophy & European Studies",
                        uni: "University of Bucharest",
                        college: "Faculty of Philosophy",
                        title: "Humanitarian Interventions:",
                        subtitle: "A General Review of Moral Justifications",
                        date: "2013-2015"
                    },
                    {
                        src: require('../../assets/hs_1.jpg'),
                        alt: "Ionel-Perlea",
                        degree: "Graduate",
                        status: null,
                        uni: "Art High School",
                        college: "'Ionel Perlea'",
                        title: "Mathematics",
                        subtitle: "Computer Science",
                        date: "2010-2013"
                    }
                ]
            }
        }
    }
</script>

<style scoped>

/*see timeline.scss */
</style>